import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerCategoryEditScreen from './BannerCategoryEditScreen'

function BannerCategoryEdit() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Chỉnh sửa danh mục')} isExist={false} />
        <BannerCategoryEditScreen/>
    </div>
  )
}

export default BannerCategoryEdit
